import { apiGetTaxFactors } from "../api/moaddian";
import { openFactorDrawer } from "../helpers/DrawerActions";
import { formatPrice } from "../helpers";
import getCurrency from "../helpers/currencyHelper";
import StatusComponent from "../components/Table/StatusComponent";
import { searchType } from "./FactorForm";

const defaultTableColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
        searchType: searchType.default,
    },
    {
        name: "عنوان",
        key: "title",
        filterParams: {
            column: "title",
            columnType: "string",
        },
        clickable: (item) => true,
        onClick: (dispatch, item) => {
            openFactorDrawer(dispatch, item);
        },
        searchType: searchType.default,
    },
    {
        name: "مشتری",
        key: "Person",
        searchKey: "nickName",
        getValue: (item) => {
            return item.Person?.nickName ?? "-";
        },
        filterParams: {
            column: "PersonId",
            columnType: "string",
            relationModelName: "Person",
            relationColumn: "nickName",
        },
        navigateKey: (item) => item.PersonId,
        navigate: "/reports/personalAccountCard?personId=",
        searchType: searchType.autocomplete,
        dataKey: {
            column: "persons",
            key: "nickName",
        },
    },
    {
        name: "مبلغ",
        key: "totalPrice",
        filterParams: {
            column: "totalPrice",
            columnType: "number",
        },
        getValue: (item) =>
            `${formatPrice(item?.totalPrice || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
        searchType: searchType.quantitative,
    },
    {
        name: "تاریخ ثبت",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        searchType: searchType.date,
    },
    {
        name: "وضعیت",
        key: "status",
        filterParams: {
            column: "status",
            columnType: "string",
        },
        searchType: searchType.status,
        Component: StatusComponent,
        getValue: (item) => {
            switch (item?.taxPaymentStatus) {
                case "sent": return "ارسال شده"
                case "Original-Approved": return " تایید شده"
                case "Original-Rejected": return "رد شده"
                case "Original-InQueue": return "در انتظار استعلام"
                case "Original-Pending": return "در انتظار استعلام"
                case "Cancelled-Pending": return "در انتظار استعلام"
                case "Original-Sent": return "در انتظار استعلام"
                case "Pending": return "در انتظار استعلام"
                case "Cancelled-Approved": return "ابطال شده"
                default: return "ارسال نشده"
            }
        },
    },
];

export const taxIndexData = [
    {
        key: "Pending",
        apiKey: "Pending",
        label: "در انتظار استعلام",
        pluralLabel: "در انتظار استعلام",
        title: "در انتظار استعلام",
        pageTitle: "سامانه مؤدیان",
        pageDescription: "",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            inquiry: {

            },
            fetch: apiGetTaxFactors,

        },
    },
    {
        key: "Approved",
        apiKey: "Approved",
        label: "تایید شده",
        pluralLabel: "تایید شده",
        title: "تایید شده",
        pageTitle: "سامانه مؤدیان",
        pageDescription: "",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            cancelled: {},
            editMoaddian: {},
            fetch: apiGetTaxFactors,
            //   delete: () => {},
            //   excel: {
            //     export: () => {},
            //     import: () => {},
            //   },
        },
    },
    {
        key: "Cancelled",
        apiKey: "Cancelled",
        label: "ابطال شده",
        pluralLabel: "ابطال شده",
        title: "ابطال شده",
        pageTitle: "سامانه مؤدیان",
        pageDescription: "",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {

            fetch: apiGetTaxFactors,
            //   delete: () => {},
            //   excel: {
            //     export: () => {},
            //     import: () => {},
            //   },
        },
    },
    {
        key: "Rejected",
        apiKey: "Rejected",
        label: "خطا دار ",
        pluralLabel: "خطا دار ",
        title: "خطا دار ",
        pageTitle: "سامانه مؤدیان",
        pageDescription: "",
        tableColumns: [...defaultTableColumns,
        {
            name: "خطا",
            key: "errors",
            size: 4,
            filterParams: {
                column: "date",
                columnType: "date",
            },
            getValue: (item) => {
                const mess = item?.errors?.map(x => {
                    return x.message

                })
                return mess?.toString()
            },
            searchType: searchType.date,
        },
        {
            name: "هشدار",
            key: "warnings",
            size: 4,
            filterParams: {
                column: "date",
                columnType: "date",
            },
            getValue: (item) => {
                const mess = item?.warnings?.map(x => {
                    return x.message

                })
                return mess?.toString()
            },
            searchType: searchType.date,
        },
        ],
        disableDateFilter: true,
        actions: {
            reSendForTax: {

            },
            fetch: apiGetTaxFactors,
            //   delete: () => {},
            //   excel: {
            //     export: () => {},
            //     import: () => {},
            //   },
        },
    },
];




export const taxNotSentIndexData = [
    {
        key: "NotSent",
        apiKey: "NotSent",
        label: "در انتظار استعلام",
        pluralLabel: "در انتظار استعلام",
        title: "در انتظار استعلام",
        pageTitle: "سامانه مؤدیان",
        pageDescription: "",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            sendForTax: {

            },
            fetch: apiGetTaxFactors,

        },
    },

];

